<template>
  <section class="section-referral content-padding">
    <template v-if="order">
      <template v-if="!displayErrorMessage">
        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <h3 class="title">
              {{ order.declined_order_data.professional_name | firstName }}
              {{ $t('message.declined_booking.title') }} #{{ order.order_code }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 offset-lg-3">
            <div class="card">
              <div class="card-body">
                <order-summary-detail :order="order"/>
                <hr>
                <table class="table table-borderless" border="0">
                  <tr>
                    <td valign="top" width="74">
                      <router-link :to="'/cleaner/'+order.declined_order_data.professional_id">
                        <img v-lazy="order.declined_order_data.professional_picture"
                             alt="'BeNeat Cleaner"
                             class="img-fluid rounded-circle" width="60">
                      </router-link>
                    </td>
                    <td valign="top">
                      <router-link :to="'/cleaner/'+order.declined_order_data.professional_id">
                        <h3>{{ order.declined_order_data.professional_name | firstName }}</h3>
                      </router-link>
                      <ul class="list-unstyled cleaner-detail-list">
                        <li>
                          <label>{{ $t('message.declined_booking.cleaning_date') }}:</label>
                          {{ order.cleaning_date | prettyDate }}
                        </li>
                        <li>
                          <label>{{ $t('message.my_reservations.service_type') }}:</label>
                          <span v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span> -
                          <template v-if="order.service_id === 1">
                            {{ order.work_hour }}
                            {{ $tc('message.hour', order.work_hour) }}
                          </template>
                          <template v-else>
                            {{ globalState.services[order.service_id] | multiLangName }}
                          </template>
                        </li>
                        <li>
                          <label>{{ $t('message.declined_booking.declining_reason') }}:</label>
                          <span
                            v-html="$options.filters.declinedReason(order.declined_order_data.issue, order.declined_order_data.remark)"></span>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </table>
                <hr>
                <template v-if="order.cancel > 0">
                  <div class="text-center declined-order-text">
                    <i class="fas fa-times-circle -status-alert"></i>
                    {{ $t('message.declined_booking.booking_is_canceled')
                    }}
                  </div>
                </template>
                <template v-else-if="order.selected_professional_id === 0 && order.cancel === 0">
                  <div class="text-center declined-order-text">
                    <i class="fas fa-check-circle -status-accepted"></i>
                    {{ $t('message.declined_booking.booking_is_sent_to_new_cleaner') }}
                  </div>
                </template>
                <template v-else-if="order.selected_professional_id > 0 && order.cancel === 0">
                  <div class="mt-4" v-if="!performProceeding">
                    <h4 class="text-center mb-4">{{ $t('message.declined_booking.confirm_to_proceed') }}</h4>
                    <div class="row mb-3 text-center">
                      <button class="btn btn-success btn-block btn-lg"
                              @click="confirmFindNewCleaner">
                        {{ $t(isFindingNewCleaner) }}
                      </button>
                      <a href="https://line.me/R/ti/p/%40hnk7011n"
                         target="_blank"
                         class="btn btn-danger btn-block btn-lg mt-4"
                         v-if="order.subscription_id !== null || order.package_id !== null || order.payment_data.method === 'bank_transfer' || order.payment_data.method === 'promptpay'">
                        {{ $t('message.my_reservations.contact_admin_to_cancel') }}
                      </a>
                      <button class="btn btn-danger btn-block btn-lg mt-4"
                              @click="confirmCancelBooking"
                              v-else-if="order.payment_data.method === 'credit_card'">
                        {{ $t(isCancelAndRefund) }}
                      </button>
                    </div>
                  </div>
                  <div class="text-center" v-else>
                    <loader/>
                    <div class="my-3">{{ proceedingMessage }}</div>
                  </div>
                </template>
                <hr>
                <div class="text-remark text-center">
                  {{ $t('message.my_reservations.declined_booking_contact') }}
                </div>
                <div class="mt-3 text-center">
                  <a href="https://line.me/R/ti/p/%40hnk7011n"
                    target="_blank"
                    class="text-center text-primary-link">
                    {{ $t('message.button.contact_admin') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="text-center">
          <h3>{{ $t('message.no_data') }}</h3>
        </div>
      </template>
    </template>
    <template v-else>
      <loader/>
    </template>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Loader from '../loader/Loader'
  import MyCleaner from './components/MyCleaner'
  import OrderSummaryDetail from './OrderSummaryDetail'

  export default {
    components: {
      OrderSummaryDetail,
      Loader,
      MyCleaner
    },
    data () {
      return {
        orderId: this.$route.query.id,
        validation: this.$route.query.validation,
        hideCloseButton: true,
        displayErrorMessage: false,
        performProceeding: false,
        proceedingMessage: ''
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        isCancelAndRefund: 'orderDetail/getIsCancelAndRefund',
        isFindingNewCleaner: 'orderDetail/getIsFindingNewCleaner',
        order: 'orderDetail/getOrderDetail',
        state: 'orderDetail/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      isFindingNewCleaner () {
        if (!this.state.isFindingNewCleaner) {
          this.fetchOrderDetail()
        }
      },
      isCanceling () {
        if (!this.state.isCanceling) {
          this.fetchOrderDetail()
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getToken']),
      ...mapActions('orderDetail', ['loadOrderDetail']),
      confirmFindNewCleaner () {
        this.$swal({
          title: this.$i18n.t('message.declined_booking.find_new_cleaner_tile'),
          text: this.$i18n.t('message.declined_booking.find_new_cleaner_detail'),
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          this.performProceeding = true
          this.proceedingMessage = this.$i18n.t('message.processing')
          // Find new cleaner
          const submitData = {
            order_id: this.orderId,
            validation: this.validation
          }
          this.$store.dispatch('orderDetail/FIND_NEW_CLEANER', submitData)
        })
      },
      confirmCancelBooking () {
        this.$swal({
          title: this.$i18n.t('message.my_reservations.cancel_refund_title_01'),
          html: this.$i18n.t('message.my_reservations.cancel_refund_detail_01'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          this.performProceeding = true
          this.proceedingMessage = this.$i18n.t('message.button.canceling')
          // Cancel and refund
          let submitData
          if (this.user) {
            submitData = {
              order_id: this.orderId,
              user_id: this.user.id,
              validation: ''
            }
          } else {
            submitData = {
              order_id: this.orderId,
              user_id: 0,
              validation: this.validation
            }
          }
          this.$store.dispatch('orderDetail/CANCEL_ORDER', submitData)
        })
      },
      async fetchOrderDetail () {
        if (this.user) {
          await this.loadOrderDetail(this.orderId)
        } else {
          const submitData = {
            order_id: this.orderId,
            validation: this.validation
          }
          await this.getToken(submitData)
          await this.loadOrderDetail(this.orderId)
        }
      }
    },
    mounted () {
      this.fetchOrderDetail()
    }
  }
</script>

<style scoped>
  h3.title {
    font-size: 110%;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/ConfirmDeclinedOrder.vue